import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get PPC (Production Plan Calendar)
export const getPPC = async (areaName = null, monthNumber = null) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/get-ppc/?area_name=${areaName}&month_num=${monthNumber}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Function to convert JSON data to FullCalendar event format
export const convertDataToEvents = (data, priorityOrder) => {
	let results = [];
	let displayedOrders = {};

	const addEvent = (bias, order, currentArea, eventDate, eventColor) => {
		results.push({
			title: bias.key,
			start: eventDate,
			allDay: true,
			color: eventColor,
			extendedProps: {
				order,
				bias,
				currentArea,
			},
		});
	};

	// Iterate through orders
	Object.keys(data).forEach((orderKey) => {
		// Get order
		const order = data[orderKey];

		// Iterate through biases
		Object.keys(order).forEach((biasKey) => {
			// Get subbias indidivual areas
			const bias = order[biasKey];
			const biasAreas = bias.areas;

			// Iterate through individual areas
			Object.keys(biasAreas).forEach((biasAreaKey) => {
				if (priorityOrder.find((x) => x.name === biasAreaKey).showing) {
					const eventDate = biasAreas[biasAreaKey].date;
					const eventColor =
						bias?.status === 'DLY'
							? '#F44336'
							: biasAreas[biasAreaKey].color;
					const currentOrder = displayedOrders[orderKey];
					if (currentOrder) {
						// if (!currentOrder.dates.includes(eventDate)) {
						// Update current order dates
						currentOrder.dates = [...currentOrder.dates, eventDate];
						// Add new event
						addEvent(
							bias,
							order,
							biasAreaKey,
							eventDate,
							eventColor
						);
						// }
					} else {
						displayedOrders[orderKey] = { dates: [eventDate] };
						// Add new event
						addEvent(
							bias,
							order,
							biasAreaKey,
							eventDate,
							eventColor
						);
					}
				}
			});
		});
	});

	return results;
};
